<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'ImportTutorPaymentsHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'import-tutor-payments',
    text: 'Import Tutor Payments',
    to: AppRoute.ImportTutorPayments,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
